// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"d52e1290","453":"500f17c0"}[chunkId] + ".chunk.js";
};